module.exports = __webpack_public_path__ + "static/media/FlightLog.40af0fd0.png";